import React from "react";
import {Modal} from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from "js-cookie";

function ModalReCapcha(props) {
  const {
    setIsModalVisible, isModalVisible,
  } = props;

  const onChangeRe = (value) => {
    if (value) {
      Cookies.set("code", value);
      setIsModalVisible(false);
    }
  }

  return (
    <>
      <Modal
        visible={isModalVisible}
        closable={false}
        footer={null}
        width="352px"
      >
        <ReCAPTCHA
          sitekey="6Lcc6CgeAAAAACdg05dBYOGfN2kEC3a2AkXyWBcr"
          onChange={onChangeRe}
        />
      </Modal>
    </>
  );
}

export default ModalReCapcha;
